import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Initialize plugins once per app
dayjs.extend(utc);
dayjs.extend(timezone);

const ALMATY_TZ = "Asia/Almaty";

export function asAlmaty(tsMs) {
  if (tsMs == null || tsMs === "") return null;
  const num = Number(tsMs);
  if (Number.isNaN(num)) return null;
  return dayjs(num).tz(ALMATY_TZ);
}

export function formatUTC(tsMs, format = "DD.MM.YYYY HH:mm") {
  if (tsMs == null || tsMs === "") return "";
  const num = Number(tsMs);
  if (Number.isNaN(num)) return "";
  return dayjs(num).utc().format(format);
}

export function formatAlmaty(tsMs, format = "DD.MM.YYYY HH:mm") {
  const d = asAlmaty(tsMs);
  return d ? d.format(format) : "";
}

// Convert a picked value (interpreted in Asia/Almaty) to UTC milliseconds
export function toUtcTimestampFromAlmatyInput(picked) {
  if (!picked) return null;
  return dayjs.tz(picked, ALMATY_TZ).utc().valueOf();
}

export const tz = {
  asAlmaty,
  formatUTC,
  formatAlmaty,
  toUtcTimestampFromAlmatyInput,
  ALMATY_TZ,
};

export default tz;
